import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/ui/Icon';
import { ICONS } from '@/constants/icons';

export const EmptyState = () => {
  const { t } = useTranslation(['posts', 'common']);

  return (
    <div className="text-center py-12 text-bs-gray">
      <Icon name={ICONS.EYE} size="lg" className="mx-auto mb-3 opacity-40" />
      <p className="text-sm font-medium">{t('add_content_to_preview')}</p>
      <p className="text-xs text-gray-400 mt-1">{t('post_will_appear_here')}</p>
    </div>
  );
};
